import React, { useState } from "react";
import { startContentExtraction } from "../../../apis/scormUpload";
import ConfirmationDialog from "../../dashboard/ConfirmationDialog";
import { Tooltip, IconButton } from "@mui/material";
import { PlayArrow } from "@mui/icons-material";

const StartExtractionButton = ({ file, onStarted, showButtonLabel = false }) => {
  const [localFile, setLocalFile] = useState(file);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "",
    message: "",
    type: "warning",
    loading: false,
    onConfirm: null,
  });

  const resetConfirmDialog = () =>
    setConfirmDialog({
      open: false,
      title: "",
      message: "",
      type: "warning",
      loading: false,
      onConfirm: null,
    });

  const handleStartExtraction = () => {
    setConfirmDialog({
      open: true,
      type: "warning",
      title: "Start Content Extraction",
      message: "Are you sure you want to start content extraction for this file?",
      onConfirm: async () => {
        setConfirmDialog((prev) => ({ ...prev, loading: true }));
        setLocalFile({ ...file, status: "content_extraction_in_progress" });

        try {
          const { data } = await startContentExtraction(file.id);
          const updatedFile = data.scorm_file;
          setLocalFile(updatedFile);
          onStarted?.(updatedFile);
        } catch (error) {
          console.error("Extraction failed:", error);
          setLocalFile({ ...file, status: "extracted" });
        } finally {
          resetConfirmDialog();
        }
      },
    });
  };

  // Hide button if file is already processing or extracting
  if (["processing", "content_extraction_in_progress"].includes(localFile.status)) {
    return null;
  }

  return (
    <>
      <Tooltip title="Start Extraction">
        <IconButton
          aria-label="Start content extraction"
          onClick={handleStartExtraction}
          color="primary"
        >
          <PlayArrow />
        </IconButton>
      </Tooltip>

      <ConfirmationDialog
        open={confirmDialog.open}
        onClose={resetConfirmDialog}
        onConfirm={confirmDialog.onConfirm}
        title={confirmDialog.title}
        message={confirmDialog.message}
        type={confirmDialog.type}
        loading={confirmDialog.loading}
        confirmText="Start Extraction"
      />
    </>
  );
};

export default StartExtractionButton;
